module.exports = __webpack_public_path__ + "img/home_on.22c5ea90.png";